// import React, {
//   Fragment,
//   useState,
//   useRef,
//   useEffect,
//   useContext,
// } from "react";
// import Select from "react-select";
// import { showToast } from "../../Common/Toast";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   FormGroup,
//   Label,
//   Button,
//   Row,
//   Col,
// } from "reactstrap";
// import { IoMdAddCircleOutline } from "react-icons/io";
// import { useDispatch, useSelector } from "react-redux";
// import { MdOutlineModeEdit } from "react-icons/md";
// import { RiDeleteBinLine } from "react-icons/ri";
// import {
//   communicationsOptions,
//   contactibilityOptions,
//   technicalSkillsOptions,
//   softSkillsOptions,
//   experienceFitOptions,
//   statusOptions,
// } from "../../../Constant";
// import AddNoteModal from "./AddNoteModal";
// import { useParams } from "react-router-dom";
// import {
//   updateCandidateInfoRequest,
//   resetCandidateInfoData,
// } from "../../../redux/recruiter/update_candidate_info/actions";

// import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
// import {
//   deleteNoteRequest,
//   resetNoteMessage,
// } from "../../../redux/recruiter/add_note/actions";
// import { extractAfterLastHyphen } from "../../Common/CommonFunction";
// import { AuthContext } from "../../../Auth/AuthContext";
// const CandidateStatus = ({ profileData }) => {
//   const dispatch = useDispatch();
//   const { cand_id, jobcad_id, type } = useParams();
//   const [showAddNote, setAddNote] = useState(false);
//   const { triggerTotalPoints } = useContext(AuthContext);
//   const toggleAddNote = () => {
//     setAddNote(!showAddNote); // Toggle the state to show/hide the modal
//   };

//   const addNote = () => {
//     setAddNote(true); // Show the modal when "Add" button is clicked
//   };

//   const deleteNote = () => {
//     if (jobcad_id) {
//       dispatch(deleteNoteRequest({ id: extractAfterLastHyphen(jobcad_id) }));
//     }
//   };
//   const user_data = JSON.parse(localStorage.getItem("user_data"));
//   const [formData, setFormData] = useState({
//     status:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.candidate_status &&
//         statusOptions.find(
//           (option) =>
//             option.value === profileData.job_candidate_details.candidate_status
//         )) ||
//       null,
//     contactibility:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.contactibility &&
//         contactibilityOptions.find(
//           (option) =>
//             option.value === profileData.job_candidate_details.contactibility
//         )) ||
//       null,
//     communications:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.communication &&
//         communicationsOptions.find(
//           (option) =>
//             option.value === profileData.job_candidate_details.communication
//         )) ||
//       null,
//     experience_fit:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.experience_fit &&
//         experienceFitOptions.find(
//           (option) =>
//             option.value === profileData.job_candidate_details.experience_fit
//         )) ||
//       null,
//     soft_skills:
//       profileData.job_candidate_details &&
//         profileData.job_candidate_details.soft_skills &&
//         profileData.job_candidate_details.soft_skills.length > 0
//         ? profileData.job_candidate_details.soft_skills
//         : null,

//     technical_skills:
//       profileData.job_candidate_details &&
//         profileData.job_candidate_details.technical_skills &&
//         profileData.job_candidate_details.technical_skills.length > 0
//         ? profileData.job_candidate_details.technical_skills
//         : null,
//     note:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.candidate_note) ||
//       "",
//     rating:
//       (profileData.job_candidate_details &&
//         profileData.job_candidate_details.candidate_rating) ||
//       0,
//   });

//   const [errors, setErrors] = useState({});

//   const validateForm = () => {
//     let formErrors = {};
//     if (!formData.status) formErrors.status = "Status is required";
//     // if (!formData.contactibility)
//     //   formErrors.contactibility = "Contactability is required";
//     // if (!formData.communications)
//     //   formErrors.communications = "Communications is required";
//     // if (!formData.technical_skills)
//     //   formErrors.technical_skills = "Technical skills are required";
//     // if (!formData.soft_skills)
//     //   formErrors.soft_skills = "Soft skills are required";
//     // if (!formData.experience_fit)
//     //   formErrors.experience_fit = "Experience fit is required";

//     // if (!formData.note.trim()) {
//     //   formErrors.note = "Note is required";
//     // }

//     setErrors(formErrors);
//     return Object.keys(formErrors).length === 0;
//   };
//   console.log("errors", errors);
//   const handleSubmit = () => {
//     if (!validateForm()) return;

//     if (jobcad_id) {
//       const data = {
//         id: extractAfterLastHyphen(jobcad_id),
//         candidate_status: formData.status ? formData.status.value : '',
//         contactibility_tag: formData.contactibility ? formData.contactibility.value : '',
//         communication_tag: formData.communications ? formData.communications.value : '',
//         exp_fit: formData.experience_fit ? formData.experience_fit.value : '',
//         technical_skills: formData.technical_skills
//           ? formData.technical_skills.map((skill) => skill.value).join(",")
//           : [],
//         soft_skills: formData.soft_skills
//           ? formData.soft_skills.map((skill) => skill.value).join(",")
//           : [],
//         rating: formData.rating ? formData.rating : '', // Ensure formData.rating is defined
//         note: formData.note || "",
//       };
//       dispatch(updateCandidateInfoRequest(data));
//     }
//   };

//   // Function to dispatch action on dropdown change
//   const handleStatusChange = (selectedOption) => {
//     setFormData({ ...formData, status: selectedOption });
//     setErrors({ ...errors, status: "" }); // Reset status error
//   };

//   const handleContactibilityChange = (selectedOption) => {
//     setFormData({ ...formData, contactibility: selectedOption });
//     setErrors({ ...errors, contactibility: "" }); // Reset contactibility error
//   };

//   const handleCommunicationsChange = (selectedOption) => {
//     setFormData({ ...formData, communications: selectedOption });
//     setErrors({ ...errors, communications: "" }); // Reset communications error
//   };

//   const handleTechnicalSkillsChange = (selectedOption) => {
//     setFormData({ ...formData, technical_skills: selectedOption });
//     setErrors({ ...errors, technical_skills: "" }); // Reset technical skills error
//   };

//   const handleSoftSkillsChange = (selectedOption) => {
//     setFormData({ ...formData, soft_skills: selectedOption });
//     setErrors({ ...errors, soft_skills: "" }); // Reset soft skills error
//   };

//   const handleExperienceFitChange = (selectedOption) => {
//     setFormData({ ...formData, experience_fit: selectedOption });
//     setErrors({ ...errors, experience_fit: "" }); // Reset experience fit error
//   };

//   const handleRatingChange = (newRating) => {
//     setFormData({
//       ...formData,
//       rating: newRating,
//     });
//     setErrors({ ...errors, rating: "" }); // Reset rating error
//   };

//   const handleChange = (e) => {
//     const value = e.target.value;
//     // Clear the error message when input changes
//     let error = "";

//     setErrors({ ...errors, note: error });

//     // Check if the input length exceeds 150 characters
//     if (value.length <= 150) {
//       setFormData({ ...formData, note: value });
//     } else {
//       // Truncate the input value to 150 characters
//       setFormData({ ...formData, note: value.slice(0, 150) });
//     }
//   };

//   let updateCandidateInfoReducerData = useSelector(
//     (state) => state.updateCandidateInfoReducer
//   );

//   useEffect(() => {
//     if (
//       updateCandidateInfoReducerData.status &&
//       updateCandidateInfoReducerData.message !== ""
//     ) {
//       showToast("success", updateCandidateInfoReducerData.message);

//       if (updateCandidateInfoReducerData.is_candidate_feedback) {
//         triggerTotalPoints("candidate_feedback", false);
//       }

//       const data = {
//         seeker_id: extractAfterLastHyphen(cand_id),
//         job_cand_id: extractAfterLastHyphen(jobcad_id),
//       };
//       dispatch(fetchJobseekerDataRequest(data));

//       dispatch(resetCandidateInfoData());
//     } else if (
//       updateCandidateInfoReducerData.status === false &&
//       updateCandidateInfoReducerData.message !== ""
//     ) {
//       showToast("error", updateCandidateInfoReducerData.message);

//       dispatch(resetCandidateInfoData());
//     }
//   }, [updateCandidateInfoReducerData]);

//   return (
//     <Fragment>
//       <Card>
//         <CardHeader className="py-3">
//           <h4 className="card-title mb-0" style={{ fontWeight: 550 }}>
//             Job Candidate Feedback
//           </h4>
//         </CardHeader>
//         <CardBody className="">
//           <Row>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="status">
//                   Status<span className="text-danger">*</span>
//                 </Label>
//                 <Select
//                   options={statusOptions}
//                   placeholder="Select status"
//                   value={formData.status}
//                   onChange={handleStatusChange} // Call the appropriate handler
//                 // isDisabled={type === "view"}
//                 />
//                 {errors.status && (
//                   <p className="text-danger">{errors.status}</p>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="contactibility">
//                   Contactability
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>
//                 <Select
//                   placeholder="Select contactibility"
//                   options={contactibilityOptions}
//                   value={formData.contactibility}
//                   onChange={handleContactibilityChange} // Call the appropriate handler
//                 // isDisabled={type === "view"}
//                 />
//                 {errors.contactibility && (
//                   <p className="text-danger">{errors.contactibility}</p>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="communications">
//                   Communications
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>
//                 <Select
//                   placeholder="Select communication"
//                   options={communicationsOptions}
//                   value={formData.communications}
//                   onChange={handleCommunicationsChange} // Call the appropriate handler
//                 //  isDisabled={type === "view"}
//                 />
//                 {errors.communications && (
//                   <p className="text-danger">{errors.communications}</p>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="technical_skills">
//                   Technical Skills
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>
//                 <Select
//                   placeholder="Select technical skills"
//                   isMulti
//                   options={technicalSkillsOptions}
//                   value={formData.technical_skills}
//                   onChange={handleTechnicalSkillsChange} // Call the appropriate handler
//                 // isDisabled={type === "view"}
//                 />
//                 {errors.technical_skills && (
//                   <p className="text-danger">{errors.technical_skills}</p>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="soft_skills">
//                   Soft Skills
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>
//                 <Select
//                   placeholder="Select soft skills"
//                   isMulti
//                   options={softSkillsOptions}
//                   value={formData.soft_skills}
//                   onChange={handleSoftSkillsChange} // Call the appropriate handler
//                 //isDisabled={type === "view"}
//                 />
//                 {errors.soft_skills && (
//                   <p className="text-danger">{errors.soft_skills}</p>
//                 )}
//               </FormGroup>
//             </Col>
//             <Col xl="6">
//               <FormGroup>
//                 <Label for="experience_fit">
//                   Experience Fit
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>
//                 <Select
//                   placeholder="Select experience"
//                   options={experienceFitOptions}
//                   value={formData.experience_fit}
//                   onChange={handleExperienceFitChange} // Call the appropriate handler
//                 //isDisabled={type === "view"}
//                 />
//                 {errors.experience_fit && (
//                   <p className="text-danger">{errors.experience_fit}</p>
//                 )}
//               </FormGroup>
//             </Col>

//             <Col xl="12">
//               <FormGroup>
//                 <Label>
//                   Note
//                   {/* <span className="text-danger">*</span> */}
//                 </Label>

//                 <textarea
//                   //  disabled={type === "view"}
//                   value={formData.note}
//                   name="note"
//                   placeholder="Enter note"
//                   onChange={handleChange}
//                   className="form-control "
//                   rows={3} // Set the number of rows here
//                 />
//                 {errors.note && <p className="text-danger">{errors.note}</p>}
//               </FormGroup>
//             </Col>
//             <Col xl="12">
//               <FormGroup>
//                 <Label>Rating</Label>
//                 <div className="stars">
//                   {[...Array(5)].map((_, index) => {
//                     const starValue = index + 1;
//                     return (
//                       <span
//                         key={starValue}
//                         onClick={() => handleRatingChange(starValue)}
//                         style={{
//                           cursor: "pointer",
//                           color:
//                             starValue <= formData.rating ? "orange" : "gray",
//                           fontSize: "30px",
//                         }}
//                       >
//                         &#9733;
//                       </span>
//                     );
//                   })}
//                 </div>
//               </FormGroup>
//             </Col>
//             {type == "view" ? null : (
//               profileData.job_candidate_details && (profileData.job_candidate_details.job_created_by == user_data.recruiter_id) &&
//               <Col xl="12">
//                 <FormGroup>
//                   <div className="mt-4">
//                     <Button
//                       color="primary"
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         width: "100%",
//                       }}
//                       onClick={handleSubmit}
//                       disabled={updateCandidateInfoReducerData.isLoading}
//                     >
//                       Update
//                     </Button>
//                   </div>
//                 </FormGroup>
//               </Col>

//             )}
//           </Row>
//         </CardBody>
//       </Card>
//     </Fragment>
//   );
// };

// export default CandidateStatus;


import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
} from "react";
import Select from "react-select";
import { showToast } from "../../Common/Toast";
import {
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { FiStar } from "react-icons/fi";
import {
  communicationsOptions,
  contactibilityOptions,
  technicalSkillsOptions,
  softSkillsOptions,
  experienceFitOptions,
  statusOptions,
} from "../../../Constant";
import {
  updateCandidateInfoRequest,
  resetCandidateInfoData,
} from "../../../redux/recruiter/update_candidate_info/actions";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { extractAfterLastHyphen, countWords } from "../../Common/CommonFunction";
import { AuthContext } from "../../../Auth/AuthContext";
import { getCandidateStatusColor } from "../../../Constant";
import star_blank from "../../../assets/images/star/star_blank.png"
import star_half from "../../../assets/images/star/star_half.png"
import star from "../../../assets/images/star/star.png"

const CandidateStatus = ({ profileData }) => {
  const dispatch = useDispatch();
  const { cand_id, jobcad_id } = useParams();
  const { triggerTotalPoints } = useContext(AuthContext);
  const user_data = JSON.parse(localStorage.getItem("user_data"));

  const [candidates, setCandidates] = useState([]);
  const [selectedCandidateIndex, setSelectedCandidateIndex] = useState(0);
  const [candidateOptions, setCandidateOptions] = useState([]);
  const [formData, setFormData] = useState({
    status: null,
    contactibility: null,
    communications: null,
    experience_fit: null,
    soft_skills: null,
    technical_skills: null,
    note: "",
    rating: 0,
    skillRatings: {}
  });
  const [errors, setErrors] = useState({});

  const handleCandidateSelectChange = (selectedOption) => {
    const newIndex = selectedOption?.index ?? candidateOptions.findIndex(option => option.value === selectedOption?.value);
    if (newIndex === undefined || newIndex === -1) return;
    setSelectedCandidateIndex(newIndex);
    setFormData(getCandidateData(candidates[newIndex]));
  };

  useEffect(() => {
    if (profileData.candidate_status) {
      setCandidates(profileData.candidate_status);
      if (profileData.candidate_status.length > 0) {
        const candidateId = extractAfterLastHyphen(jobcad_id);
        const candidateIndex = profileData.candidate_status.findIndex(
          candidate => candidate.id == candidateId
        );
        const newIndex = candidateIndex !== -1 ? candidateIndex : 0;
        setSelectedCandidateIndex(newIndex);
        setFormData(getCandidateData(profileData.candidate_status[newIndex]));

        // Build candidate options for dropdown
        const options = profileData.candidate_status.map((candidate, index) => ({
          label: candidate.job_name || candidate.job_title || `Job ${candidate.id}`,
          value: candidate.id,
          index: index,
          status: candidate.candidate_status || "Unknown"
        }));
        setCandidateOptions(options);
      }
    }
  }, [profileData, jobcad_id]);

  const getCandidateData = (candidate) => {
    const mandatorySkills = candidate?.mandatory_skills || [];
    // Extract skill ratings from the candidate data
    const skillRatings = mandatorySkills.reduce((acc, skill) => {
      acc[skill.label] = skill.rating ? Number(skill.rating) : 0; // Use skill.rating from backend, default to 0
      return acc;
    }, {});
    return {
      status: statusOptions.find(option => option.value === candidate.candidate_status) || null,
      contactibility: contactibilityOptions.find(option => option.value === candidate.contactibility) || null,
      communications: communicationsOptions.find(option => option.value === candidate.communication) || null,
      experience_fit: experienceFitOptions.find(option => option.value === candidate.experience_fit) || null,
      soft_skills: candidate.soft_skills || [],
      technical_skills: candidate.technical_skills || [],
      note: candidate.candidate_note || "",
      rating: candidate.candidate_rating || 0,
      last_status: candidate.candidate_last_status || "", // Assuming this is the key for last status
      job_title: candidate.job_title || "", // Assuming this is the key for job title
      hire_date: candidate.hire_date || "", // Assuming this is the key for hire date
      skillRatings: skillRatings,
    };
  };

  const validateForm = () => {
    const formErrors = {};
    if (!formData.status) formErrors.status = "Status is required";

    const isHiredOrInterviewed = ["Hired", "Interviewed"].includes(formData.status?.value);
    // Check core skills if candidate is hired/interviewed
    if (isHiredOrInterviewed) {
      candidates[selectedCandidateIndex]?.mandatory_skills?.forEach(skill => {
        if (formData.skillRatings[skill.label] === 0 ||
          !formData.skillRatings[skill.label]) {
          formErrors[`skill_${skill.label}`] = `Rating for ${skill.label} is required`;
        }
      });
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };



  const handleSubmit = () => {
    if (!validateForm()) return;

    const selectedCandidate = candidates[selectedCandidateIndex];
    const data = {
      id: selectedCandidate.id,
      candidate_status: formData.status?.value || '',
      contactibility_tag: formData.contactibility?.value || '',
      communication_tag: formData.communications?.value || '',
      exp_fit: formData.experience_fit?.value || '',
      technical_skills: formData.technical_skills?.map(skill => skill.value).join(",") || '',
      soft_skills: formData.soft_skills?.map(skill => skill.value).join(",") || '',
      rating: formData.rating,
      note: formData.note,
      skill_ratings: formData.skillRatings, // Include skill ratings
    };
    dispatch(updateCandidateInfoRequest(data));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (name) => (selectedOption) => {
    setFormData({ ...formData, [name]: selectedOption });
    setErrors({ ...errors, [name]: "" });
  };

  const updateCandidateInfoReducerData = useSelector(
    (state) => state.updateCandidateInfoReducer
  );
  const isUpdatingStatus = updateCandidateInfoReducerData.isLoading;

  useEffect(() => {
    if (
      updateCandidateInfoReducerData.status &&
      updateCandidateInfoReducerData.message !== ""
    ) {
      showToast("success", updateCandidateInfoReducerData.message);

      if (updateCandidateInfoReducerData.is_candidate_feedback) {
        triggerTotalPoints("candidate_feedback", false);
      }

      const data = {
        seeker_id: extractAfterLastHyphen(cand_id),
        job_cand_id: extractAfterLastHyphen(jobcad_id),
      };

      dispatch(fetchJobseekerDataRequest(data));
      dispatch(resetCandidateInfoData());
    } else if (
      updateCandidateInfoReducerData.status === false &&
      updateCandidateInfoReducerData.message !== ""
    ) {
      showToast("error", updateCandidateInfoReducerData.message);
      dispatch(resetCandidateInfoData());
    }
  }, [updateCandidateInfoReducerData]);

  const selectedJob = candidates[selectedCandidateIndex];
  const selectedCandidateOption = candidateOptions.find(opt => opt.index === selectedCandidateIndex) || null;
  const jobName = selectedJob?.job_name ? String(selectedJob.job_name).trim() : selectedJob?.job_title || "";
  const feedbackTitle = jobName
    ? `Candidate feedback for the ${jobName}`
    : "Candidate feedback";

  // Construct and style the feedback sentence
  const candidateFeedback = () => {
    // Construct the feedback sentence
    // Check if profileData and candidate_last_status exist
    if (profileData && profileData.candidate_last_status) {
      const { last_status, job_title, hire_date, sentence } = profileData.candidate_last_status;
      // Check if all required fields are present
      if (last_status && job_title && hire_date) {
        const formattedDate = new Date(hire_date).toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
        // Get the status color class
        const statusColorClass = getCandidateStatusColor(last_status);
        return (
          <div className="feedback-display mt-1">
            <span className={`status-badge ${statusColorClass}`}>
              {sentence}
              {/* {last_status} */}
            </span>
            {/* <span className="feedback-text">
              as a <strong>{job_title}</strong> on {formattedDate}
            </span> */}
          </div>
        );
      }
    }
    // Return a default message if no feedback is available
    return null;
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className="py-3 d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column" style={{ flex: 1 }}>
            <h4 className="card-title mb-1" style={{ fontWeight: 550 }}>
              {jobName ? (
                <>
                  Candidate feedback for the <span style={{ color: "#7366ff" }}>{jobName}</span>
                </>
              ) : (
                "Candidate feedback"
              )}
            </h4>
            {candidateFeedback()} {/* Display the feedback sentence */}
          </div>

          {/* Job selector dropdown */}
          <div style={{ width: '300px', marginLeft: '20px' }}>
            <Select
              options={candidateOptions}
              value={selectedCandidateOption}
              onChange={handleCandidateSelectChange}
              placeholder="Select candidate..."
              isSearchable={true}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => String(option.value)}
              formatOptionLabel={(option) => (
                <div className="d-flex align-items-center justify-content-between">
                  <span>{option.label}</span>
                  <span className={`badge ms-2 ${getCandidateStatusColor(option.status)}`}>
                    {option.status}
                  </span>
                </div>
              )}
              noOptionsMessage={() => "No candidate jobs available"}
            />
          </div>
        </CardHeader>

        <CardBody>
          <Row>
            <Col xl="6">
              <FormGroup>
                <Label for="status">
                  Main skills
                </Label>
                {candidates[selectedCandidateIndex]?.mandatory_skills?.map((skill) => {
                  const isCoreSkill = candidates[selectedCandidateIndex]?.core_skills?.some(
                    coreSkill => coreSkill.label === skill.label
                  );

                  const isMandatory = ["Hired", "Interviewed"].includes(formData.status?.value) && isCoreSkill;

                  const skillError = errors[`skill_${skill.label}`]; // Get the error for this skill
                  const currentRating = formData.skillRatings[skill.label] || 0; // Get the current rating for the skill
                  // Function to handle rating change for a specific skill
                  const handleSkillRatingChange = (newRating) => {
                    // Update the skill rating in the formData or a separate state if needed
                    setFormData((prevData) => ({
                      ...prevData,
                      skillRatings: {
                        ...prevData.skillRatings,
                        [skill.label]: newRating, // Use skill label as key
                      },
                    }));
                  };
                  return (
                    <div key={skill.label} className="d-flex align-items-center skill-item mb-2">
                      <span className={`me-2 ${isCoreSkill ? "fw-bolder text-primary" : "text-black"}`}>
                        {isMandatory && (
                          <span className="ms-1" style={{ color: "red" }}>*</span>
                        )} {skill.label}
                        {isCoreSkill && (
                          <FiStar
                            size={8}
                            className="ms-1"
                            style={{
                              color: "blue",
                              verticalAlign: "middle"
                            }}
                          />
                        )}
                      </span>

                      <div className="star-container ms-4">
                        {[...Array(5)].map((_, i) => {
                          const starValue = i + 1; // Star value from 1 to 5
                          return (
                            <span
                              key={i}
                              onClick={() => handleSkillRatingChange(starValue)} // Update rating on click
                              style={{
                                cursor: "pointer",
                                color: starValue <= currentRating ? "orange" : "gray", // Change color based on rating
                                fontSize: "18px", // Adjust size as needed
                                marginRight: "2px",
                              }}
                            >
                              &#9733; {/* Star character */}
                            </span>
                          );
                        })}
                      </div>
                      {skillError && <p className="text-danger small mt-1">{skillError}</p>}
                    </div>
                  );
                })}
              </FormGroup>


            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="status">
                  Status<span className="text-danger">*</span>
                </Label>
                <Select
                  options={statusOptions}
                  placeholder="Select status"
                  value={formData.status}
                  onChange={handleSelectChange('status')}
                />
                {errors.status && (
                  <p className="text-danger small mt-1">{errors.status}</p>
                )}
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="contactibility">Contactability</Label>
                <Select
                  placeholder="Select contactibility"
                  options={contactibilityOptions}
                  value={formData.contactibility}
                  onChange={handleSelectChange('contactibility')}
                />
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="communications">Communications</Label>
                <Select
                  placeholder="Select communication"
                  options={communicationsOptions}
                  value={formData.communications}
                  onChange={handleSelectChange('communications')}
                />
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="technical_skills">Technical Skills</Label>
                <Select
                  placeholder="Select technical skills"
                  isMulti
                  options={technicalSkillsOptions}
                  value={formData.technical_skills}
                  onChange={handleSelectChange('technical_skills')}
                />
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="soft_skills">Soft Skills</Label>
                <Select
                  placeholder="Select soft skills"
                  isMulti
                  options={softSkillsOptions}
                  value={formData.soft_skills}
                  onChange={handleSelectChange('soft_skills')}
                />
              </FormGroup>
            </Col>
            <Col xl="6">
              <FormGroup>
                <Label for="experience_fit">Experience Fit</Label>
                <Select
                  placeholder="Select experience"
                  options={experienceFitOptions}
                  value={formData.experience_fit}
                  onChange={handleSelectChange('experience_fit')}
                />
              </FormGroup>
            </Col>
            <Col xl="12">
              <FormGroup>
                <Label>Note</Label>
                <textarea
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  className="form-control"
                  rows={3}
                  maxLength={600}
                />
                <small className="text-muted">
                  Words: {countWords(formData.note)}
                </small>
              </FormGroup>
            </Col>
            <Col xl="12">
              <FormGroup>
                <Label>Rating</Label>
                <div className="stars">
                  {[...Array(5)].map((_, index) => {
                    const starValue = index + 1;
                    return (
                      <span
                        key={starValue}
                        onClick={() => setFormData({ ...formData, rating: starValue })}
                        style={{
                          cursor: "pointer",
                          color: starValue <= formData.rating ? "orange" : "gray",
                          fontSize: "30px",
                          marginRight: "5px"
                        }}
                      >
                        &#9733;
                      </span>
                    );
                  })}
                </div>
              </FormGroup>
            </Col>
            <Col xl="12" className="mt-3">
              <Button
                color="primary"
                onClick={handleSubmit}
                disabled={isUpdatingStatus}
                style={{ width: '100%' }}
              >
                {isUpdatingStatus ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Updating...
                  </>
                ) : (
                  'Update Status'
                )}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CandidateStatus;
